import api from "./core";

export default {
  async getClient($id) {
    const result = await api.get(`api/portal/Patients/${$id}`);
    return result.data;
  },
  async getMedicationRoutes() {
    const result = await api.post(`api/portal/MedicationRoute`, {});
    return result.data;
  },
  async getMeasurements() {
    const result = await api.post(`api/portal/UnitOfMeasurement`, {});
    return result.data;
  },
  async getDiagnosisCodeStatuses() {
    const result = await api.post(`api/portal/DiagnosisCodeStatus`, {});
    return result.data;
  },
  async getGenders() {
    const result = await api.get(`api/portal/Catalog/Gender`, {});
    return result.data;
  },
  async getStates() {
    const result = await api.get(`api/portal/Catalog/States`, {});
    return result.data;
  },
  async getAvailableServices(existingPatient) {
    const result = await api.get(
      `api/portal/Catalog/Services/${existingPatient}`,
      {}
    );
    return result.data;
  },
  async getLocations() {
    const result = await api.get(`api/portal/Catalog/Locations`, {});
    return result.data;
  },
  async getInsuranceCompanies() {
    const result = await api.post(`api/portal/Catalog/InsuranceCompany`, {
      page: 0,
      pageSize: 1000000
    });
    return result.data.records;
  },
  async getRelationships() {
    const result = await api.get(`api/portal/Catalog/Relationships`, {});
    return result.data;
  },
  async getClinicians(data) {
    const result = await api.post(
      `api/portal/AppointmentRequests/Clinicians`,
      data
    );
    return result.data;
  },
  async getPlacesOfService(locationId = null) {
    const params = locationId ? { locationId } : {};
    const result = await api.get(`api/portal/Catalog/PlacesOfService`, { params });
    return result.data;
  }
};
